/**
 * Filter cards to return max 2 card with different active status.
 */
export function filterValidCards(cards) {
  const validCards = [];
  if (cards.length < 2) return cards;

  const activeCard = cards.find(card => card.isLive === true);
  const inactiveCard = cards.find(card => card.isLive === false);
  if (activeCard) {
    validCards.push(activeCard);
  }
  if (inactiveCard) {
    validCards.push(inactiveCard);
  }

  return validCards;
}



// WEBPACK FOOTER //
// ./src/modules/card/CardUtils.js